import React from "react";

interface SwapIconProps {
  width?: string;
  height?: string;
  color?: string;
  className?: string;
  rotation?: number;
}

export const SwapIcon: React.FC<SwapIconProps> = ({
  width = "20",
  height = "20",
  color = "#0056d6",
  className = "",
  rotation = 90,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{
        transform: `rotate(${rotation}deg)`,
        transformOrigin: "center",
      }}
    >
      <g id="SwapIcon">
        {/* Top arrow pointing right */}
        <path
          d="M4 8L8 4L12 8"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          transform="rotate(90 8 6)"
        />
        {/* Top horizontal line */}
        <path
          d="M4 6H20"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        {/* Bottom arrow pointing left */}
        <path
          d="M20 16L16 20L12 16"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          transform="rotate(-90 16 18)"
        />
        {/* Bottom horizontal line */}
        <path
          d="M20 18H4"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
